import { Menu, Transition } from '@headlessui/react';
import React from 'react';

import Timer from '../components/Timer';
import { AuthContext } from '../context/authContext';
import { _retrieveLocalStorageItem } from '../utils/localStorage';
import { HeaderProps, Profile } from './Header.type';

const Header = (props: HeaderProps) => {
	const [top, setTop] = React.useState(true);
	const [profile, setProfile] = React.useState<Profile>(null);
	const [initials, setInitials] = React.useState<string>('');
	const { logout } = React.useContext(AuthContext);

	React.useEffect(() => {
		const scrollHandler = () => {
			window.pageYOffset > 10 ? setTop(false) : setTop(true);
		};
		window.addEventListener('scroll', scrollHandler);
		return () => window.removeEventListener('scroll', scrollHandler);
	}, [top]);

	React.useEffect(() => {
		getProfileFromLocalStorage();
	}, []);

	const getProfileFromLocalStorage = async () => {
		const profile = await _retrieveLocalStorageItem('profile');
		if (profile) {
			const profileParse = JSON.parse(profile);

			const initials =
				profileParse &&
				profileParse.name
					.split(' ')
					.reduce(
						(result: string, currentWord: string) =>
							result + currentWord.charAt(0),
						'',
					);
			setProfile(profileParse);
			setInitials(initials);
		}
	};

	const onLogout = () => logout();

	if (!profile && props.type !== 'outletcrew') {
		return <div />;
	}

	return (
		<header className="fixed bg-white w-full z-50 md:bg-opacity-90 transition duration-300 ease-in-out drop-shadow-x">
			<div className="max-w-full">
				<div className="flex items-center justify-between tablet:h-20 mobile:h-15 laptop:mx-36 tablet:mx-8 mobile:mx-2">
					<div className="flex items-center">
						<div className="mr-3">
							<img
								src="/images/logo.svg"
								className="w-14 h-14 mobile: w-10 h-10"
							/>
						</div>
						<div>
							<div className="text-gray-gray700 laptop:text-large tablet:text-large mobile:text-regular font-interRegular capitalize">
								{props.title}
							</div>
							<div className="text-gray-gray700 laptop:text-extraLarge2 tablet:text-large mobile:text-regular font-interMedium capitalize">
								{props.type !== 'outletcrew' ? profile.role : 'Stock Form'}
							</div>
						</div>
					</div>
					{props.type !== 'outletcrew' && (
						<Menu as="div" className="relative inline-block">
							<Menu.Button className="bg-black w-10 h-10 rounded-full flex items-center justify-center">
								<div className="text-medium text-white font-interMedium uppercase">
									{initials}
								</div>
							</Menu.Button>
							<Transition
								as={React.Fragment}
								enter="transition ease-out duration-100"
								enterFrom="transform opacity-0 scale-95"
								enterTo="transform opacity-100 scale-100"
								leave="transition ease-in duration-75"
								leaveFrom="transform opacity-100 scale-100"
								leaveTo="transform opacity-0 scale-95"
							>
								<Menu.Items className="absolute w-96 right-0 mt-2.5 p-4 origin-center bg-white rounded-xl shadow-lg focus:outline-none">
									<div className="px-1 py-1">
										<Menu.Item>
											{() => (
												<div>
													<div className="flex items-center mb-6">
														<div className="bg-black w-10 h-10 rounded-full flex items-center justify-center p-4 mr-5">
															<div className="text-medium text-white font-interMedium uppercase">
																{initials}
															</div>
														</div>
														<div>
															<div className="text-extraLarge2 text-gray-gray700 font-interMedium w-68 truncate mb-2">
																{profile.name}
															</div>
															<div className="text-large text-gray-gray600 font-interRegular w-68 truncate">
																{profile.email}
															</div>
														</div>
													</div>
													<div
														onClick={onLogout}
														className="flex justify-between items-center cursor-pointer"
													>
														<div className="text-large text-danger-default font-interRegular">
															Keluar
														</div>
														<div>
															<img src="/images/chevronRightRed.svg" />
														</div>
													</div>
												</div>
											)}
										</Menu.Item>
									</div>
								</Menu.Items>
							</Transition>
						</Menu>
					)}
					{props.type === 'outletcrew' && !props.isExpired && props.time && (
						<Timer expiryTimestamp={props.time} onExpire={props.onExpire} />
					)}
				</div>
			</div>
		</header>
	);
};

export default Header;
